(function () {
  var root = document.getElementById("biopods-chat-widget");
  if (!root) {
    return;
  }

  var apiBase = String(root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  if (!apiBase) {
    return;
  }

  var toggleButton = root.querySelector(".biopods-chat__toggle");
  var closeButton = root.querySelector(".biopods-chat__close");
  var panel = root.querySelector(".biopods-chat__panel");
  var messagesEl = root.querySelector("[data-chat-messages]");
  var suggestionsEl = root.querySelector("[data-chat-suggestions]");
  var formEl = root.querySelector("[data-chat-form]");
  var inputEl = root.querySelector(".biopods-chat__input");
  var statusEl = root.querySelector("[data-chat-status]");
  var experienceEl = root.querySelector("[data-chat-experience]");
  var experienceTextEl = root.querySelector(".biopods-chat__experience-textarea");
  var experienceSubmitEl = root.querySelector("[data-chat-experience-submit]");
  var experienceStatusEl = root.querySelector("[data-chat-experience-status]");

  var SESSION_STORAGE_KEY = "biopods-chat-session-id";
  var HISTORY_STORAGE_KEY = "biopods-chat-history-v1";
  var EXPERIENCE_STORAGE_KEY = "biopods-chat-experience-v1";
  var MAX_HISTORY_ITEMS = 12;
  var MAX_HISTORY_MESSAGES_SENT = 6;
  var PATHOLOGY_PAGE_KEYS = {
    "achilles-tendonitis": true,
    "arthritic-foot": true,
    "bunionettes": true,
    "bunions-and-hallux-valgus": true,
    "corns-and-calluses": true,
    "diabetic-foot": true,
    "hammer-toes": true,
    "heel-spurs": true,
    "hip-pain": true,
    "iliotibial-band-syndrome": true,
    "knee-pain": true,
    "lower-back-pain": true,
    "metatarsalgia": true,
    "morton-s-neuroma": true,
    "overpronation": true,
    "oversupination": true,
    "plantar-fasciitis": true,
    "pre-and-post-surgery-rehabilitation": true,
    "sesamoiditis": true,
    "shin-splints": true,
    "tired-achy-feet": true,
    "turf-toe": true
  };
  var FAQ_PAGE_KEYS = {
    "frequently-asked-questions": true,
    "product-care": true,
    "trim-your-bfs-insoles": true,
    "contact": true
  };
  var SIZING_PAGE_KEYS = {
    "foot-measurement-instructions": true
  };
  var EDUCATION_PAGE_KEYS = {
    "all-foot-conditions": true,
    "customized-footwear-for-a-perfect-fit": true,
    "foot-strength-test": true,
    "getting-started-footwear": true,
    "good-shoes": true,
    "healthcare-professionals": true,
    "how-to-lace-your-shoes": true,
    "innovative-design": true,
    "pain-relief": true,
    "performance": true,
    "resources-page": true,
    "the-science": true,
    "transformative-technologies": true,
    "what-is-functional-foot-strength": true,
    "what-to-expect": true,
    "what-to-expect-shoes": true,
    "whats-the-difference-between-biopods-and-barefoot-science": true
  };

  var state = {
    sessionId: window.localStorage.getItem(SESSION_STORAGE_KEY) || "",
    started: false,
    sending: false,
    typingId: "",
    history: loadStoredHistory(),
    experienceSubmitted: loadExperienceSubmitted(),
  };

  hydrateHistory();

  toggleButton.addEventListener("click", function () {
    setPanelOpen(panel.hidden);
  });

  closeButton.addEventListener("click", function () {
    setPanelOpen(false);
  });

  formEl.addEventListener("submit", function (event) {
    event.preventDefault();
    sendCurrentInput();
  });

  inputEl.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      sendCurrentInput();
    }
  });

  experienceSubmitEl.addEventListener("click", function () {
    submitExperienceFeedback();
  });

  async function sendCurrentInput() {
    var message = String(inputEl.value || "").trim();
    if (!message || state.sending) {
      return;
    }

    var conversationHistory = buildConversationHistory();

    inputEl.value = "";
    clearStatus();
    appendMessage({
      role: "user",
      text: message,
    });
    persistHistory();
    scheduleScrollToLatestQuestion();

    state.sending = true;
    inputEl.setAttribute("disabled", "disabled");
    root.querySelector(".biopods-chat__send").setAttribute("disabled", "disabled");
    showTyping();

    try {
      await ensureSessionStarted();

      var response = await postJson("/api/chat/message", {
        sessionId: state.sessionId,
        message: message,
        pageUrl: getPageUrl(),
        pageType: getPageType(),
        productHandle: root.getAttribute("data-product-handle") || "",
        locale: getLocale(),
        history: conversationHistory,
      });

      hideTyping();

      if (!response || !response.answer) {
        throw new Error((response && response.error) || "Chat response failed.");
      }

      appendMessage({
        role: "assistant",
        text: response.answer || "I couldn't find a clear answer right now.",
        messageId: response.messageId || "",
        sources: Array.isArray(response.sources) ? response.sources : [],
        answerState: response.answerState || "fallback",
      });

      renderSuggestions(Array.isArray(response.suggestions) ? response.suggestions : []);

      if (response.askExperienceFeedback && !state.experienceSubmitted) {
        experienceEl.hidden = false;
      }

      persistHistory();
      scheduleScrollToLatestQuestion();
    } catch (error) {
      hideTyping();
      setStatus("The assistant is having trouble responding right now. Please try again.");
      appendMessage({
        role: "assistant",
        text: "I’m sorry, but I’m having trouble answering right now. Please try again in a moment.",
        answerState: "fallback",
      });
      persistHistory();
      scheduleScrollToLatestQuestion();
    } finally {
      state.sending = false;
      inputEl.removeAttribute("disabled");
      root.querySelector(".biopods-chat__send").removeAttribute("disabled");
      inputEl.focus();
    }
  }

  async function ensureSessionStarted() {
    if (state.started) {
      return;
    }

    setStatus("Connecting to the Biopods assistant...");

    var response = await postJson("/api/chat/start", {
      sessionId: state.sessionId || "",
      pageUrl: getPageUrl(),
      pageType: getPageType(),
      productHandle: root.getAttribute("data-product-handle") || "",
      locale: getLocale(),
      referrer: document.referrer || "",
    });

    if (!response || !response.sessionId) {
      throw new Error((response && response.error) || "Unable to start the chat session.");
    }

    state.sessionId = response.sessionId;
    state.started = true;
    window.localStorage.setItem(SESSION_STORAGE_KEY, state.sessionId);

    if (!state.history.length && response.greeting) {
      appendMessage({
        role: "assistant",
        text: response.greeting,
        answerState: "answered",
      });
    }

    renderSuggestions(Array.isArray(response.suggestions) ? response.suggestions : []);
    persistHistory();
    clearStatus();
  }

  async function submitFeedback(messageId, feedbackType, button) {
    if (!messageId || !feedbackType) {
      return;
    }

    var buttons = button.closest(".biopods-chat__feedback").querySelectorAll("button");
    buttons.forEach(function (item) {
      item.setAttribute("disabled", "disabled");
    });

    try {
      await postJson("/api/chat/feedback", {
        sessionId: state.sessionId,
        messageId: messageId,
        feedbackType: feedbackType,
      });

      button.textContent = feedbackType === "helpful" ? "Thanks" : "Noted";
    } catch (_error) {
      buttons.forEach(function (item) {
        item.removeAttribute("disabled");
      });
      setStatus("We couldn't record that feedback just now.");
    }
  }

  async function submitExperienceFeedback() {
    var feedbackText = String(experienceTextEl.value || "").trim();
    if (!feedbackText || state.experienceSubmitted) {
      return;
    }

    experienceSubmitEl.setAttribute("disabled", "disabled");
    experienceStatusEl.textContent = "Sending...";

    try {
      await postJson("/api/chat/experience-feedback", {
        sessionId: state.sessionId,
        pageUrl: getPageUrl(),
        feedback: feedbackText,
      });

      state.experienceSubmitted = true;
      window.localStorage.setItem(EXPERIENCE_STORAGE_KEY, "1");
      experienceStatusEl.textContent = "Thank you for the feedback.";
      experienceTextEl.value = "";
      experienceTextEl.setAttribute("disabled", "disabled");
    } catch (_error) {
      experienceStatusEl.textContent = "We couldn't send that feedback just now.";
      experienceSubmitEl.removeAttribute("disabled");
      return;
    }

    experienceSubmitEl.setAttribute("disabled", "disabled");
  }

  function renderSuggestions(items) {
    suggestionsEl.innerHTML = "";
    suggestionsEl.hidden = !items.length;

    items.forEach(function (item) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "biopods-chat__suggestion";
      button.textContent = item;
      button.addEventListener("click", function () {
        inputEl.value = item;
        sendCurrentInput();
      });
      suggestionsEl.appendChild(button);
    });
  }

  function normalizeComparableUrl(url) {
    var raw = String(url || "").trim();

    if (!raw) {
      return "";
    }

    try {
      var parsed = new window.URL(raw, window.location.origin);
      return String(parsed.pathname || "").replace(/\/+$/, "");
    } catch (_error) {
      return raw.split("#")[0].replace(/\/+$/, "");
    }
  }

  function normalizeStorefrontHref(url) {
    return String(url || "")
      .trim()
      .replace(/^https:\/\/biopods\.com\/en-ca(?=\/(pages|collections|products|policies)\b)/i, "https://biopods.com")
      .replace(/^\/en-ca(?=\/(pages|collections|products|policies)\b)/i, "");
  }

  function buildSourceHref(source) {
    var normalizedSource = normalizeSource(source);
    var rawUrl = String((normalizedSource && normalizedSource.url) || "").trim();
    var normalizedPathKey = String((normalizedSource && normalizedSource.normalizedPathKey) || "").trim();
    var localeCode = String((normalizedSource && normalizedSource.localeCode) || getLocale() || "").trim().toLowerCase();

    if (/^https?:\/\//i.test(rawUrl)) {
      return normalizeStorefrontHref(rawUrl);
    }

    if (normalizedPathKey) {
      return normalizeStorefrontHref((localeCode ? "/" + localeCode : "") + normalizedPathKey);
    }

    return normalizeStorefrontHref(rawUrl);
  }

  function humanizePathLabel(path) {
    return String(path || "")
      .replace(/^\/+/, "")
      .split("/")
      .filter(Boolean)
      .pop()
      .replace(/-/g, " ")
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      })
      .trim();
  }

  function getSourceLabel(source) {
    var normalizedSource = normalizeSource(source);
    var explicitLabel = String((normalizedSource && normalizedSource.label) || "").trim();
    var path = String((normalizedSource && normalizedSource.normalizedPathKey) || "").toLowerCase();
    var title = String((normalizedSource && normalizedSource.title) || "").trim();

    if (explicitLabel) {
      return explicitLabel;
    }

    if (path === "/pages/the-science") {
      return "Learn more about the science";
    }

    if (path === "/pages/transformative-technologies") {
      return "Learn more about the technologies";
    }

    if (path === "/pages/foot-strength-test") {
      return "Take the foot strength test";
    }

    if (path === "/pages/what-is-functional-foot-strength") {
      return "Learn about functional foot strength";
    }

    if (path === "/pages/whats-the-difference-between-biopods-and-barefoot-science") {
      return "See the full comparison";
    }

    if (path === "/collections/biopods-and-barefoot-science-insoles") {
      return "Explore Biopods and Barefoot Science insoles";
    }

    if (path === "/pages/customized-footwear-for-a-perfect-fit") {
      return "Learn more about fit and footwear";
    }

    if (path === "/pages/performance") {
      return "Learn about performance benefits";
    }

    if (path === "/pages/pain-relief") {
      return "Learn about pain relief";
    }

    if (path === "/pages/what-to-expect" || path === "/pages/what-to-expect-shoes") {
      return "Learn what to expect";
    }

    if ((normalizedSource && normalizedSource.pageType) === "pathology" && path) {
      return "Learn more about " + humanizePathLabel(path);
    }

    if (path && path.indexOf("/pages/") === 0) {
      return "Learn more about " + humanizePathLabel(path);
    }

    return title
      .replace(/\s*-\s*Biopods.*$/i, "")
      .replace(/\s*–\s*Biopods.*$/i, "")
      .trim() || (normalizedSource && normalizedSource.url) || "";
  }

  function appendSources(wrapper, sourcesList) {
    var currentPageUrl = normalizeComparableUrl(getPageUrl());
    var sources = document.createElement("div");
    sources.className = "biopods-chat__sources";
    var label = document.createElement("p");
    label.className = "biopods-chat__sources-label";
    label.textContent = "Related pages";
    sources.appendChild(label);

    var seen = {};

    sourcesList.forEach(function (source) {
      var normalizedSource = normalizeSource(source);

      if (!normalizedSource || !normalizedSource.url) {
        return;
      }

      var sourceHref = buildSourceHref(normalizedSource);
      var sourceUrl = normalizeComparableUrl(sourceHref);
      var labelText = getSourceLabel(normalizedSource);
      var labelKey = String(labelText || "").toLowerCase();

      if (!labelText || sourceUrl === currentPageUrl || seen[labelKey]) {
        return;
      }

      seen[labelKey] = true;

      var link = document.createElement("a");
      link.className = "biopods-chat__source";
      link.href = sourceHref;
      link.textContent = labelText;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      sources.appendChild(link);
    });

    if (sources.children.length > 1) {
      wrapper.appendChild(sources);
    }
  }

  function appendMessage(message) {
    var wrapper = document.createElement("div");
    wrapper.className = "biopods-chat__message biopods-chat__message--" + message.role;
    wrapper.setAttribute("data-chat-role", message.role);

    var bubble = document.createElement("div");
    bubble.className = "biopods-chat__bubble";
    bubble.innerHTML = formatBubbleHtml(message.text || "");
    wrapper.appendChild(bubble);

    if (Array.isArray(message.sources) && message.sources.length) {
      appendSources(wrapper, message.sources);
    }

    messagesEl.appendChild(wrapper);

    state.history.push({
      role: message.role,
      text: message.text,
      messageId: message.messageId || "",
      sources: Array.isArray(message.sources) ? message.sources : [],
      answerState: message.answerState || "",
    });

    if (state.history.length > MAX_HISTORY_ITEMS) {
      state.history = state.history.slice(state.history.length - MAX_HISTORY_ITEMS);
    }
  }

  function hydrateHistory() {
    if (!state.history.length) {
      return;
    }

    state.history.forEach(function (message) {
      appendMessageToDom(message);
    });

    scheduleScrollToLatestQuestion();
  }

  function appendMessageToDom(message) {
    var wrapper = document.createElement("div");
    wrapper.className = "biopods-chat__message biopods-chat__message--" + message.role;
    wrapper.setAttribute("data-chat-role", message.role);

    var bubble = document.createElement("div");
    bubble.className = "biopods-chat__bubble";
    bubble.innerHTML = formatBubbleHtml(message.text || "");
    wrapper.appendChild(bubble);

    if (Array.isArray(message.sources) && message.sources.length) {
      appendSources(wrapper, message.sources);
    }

    messagesEl.appendChild(wrapper);
  }

  function persistHistory() {
    try {
      window.localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(state.history));
    } catch (_error) {
      // Ignore storage write failures.
    }
  }

  function loadStoredHistory() {
    try {
      return JSON.parse(window.localStorage.getItem(HISTORY_STORAGE_KEY) || "[]");
    } catch (_error) {
      return [];
    }
  }

  function loadExperienceSubmitted() {
    return window.localStorage.getItem(EXPERIENCE_STORAGE_KEY) === "1";
  }

  function formatBubbleHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n\n/g, "<br><br>")
      .replace(/\n/g, "<br>");
  }

  function buildConversationHistory() {
    return state.history
      .slice(-MAX_HISTORY_MESSAGES_SENT)
      .map(function (message) {
        return {
          role: message.role,
          content: String(message.text || "").trim(),
        };
      })
      .filter(function (message) {
        return message.role && message.content;
      });
  }

  function getLocale() {
    return String(root.getAttribute("data-locale") || "").trim().toLowerCase() || "en-ca";
  }

  function getCurrentPath() {
    try {
      return String(new window.URL(getPageUrl(), window.location.origin).pathname || "").toLowerCase().replace(/\/+$/, "");
    } catch (_error) {
      return window.location.pathname.toLowerCase().replace(/\/+$/, "");
    }
  }

  function getPageKeyFromPath(path) {
    return String(path || "")
      .replace(/^\/+/, "")
      .split("/")
      .filter(Boolean)
      .pop() || "";
  }

  function getPageType() {
    var explicit = String(root.getAttribute("data-page-type") || "").trim().toLowerCase();
    var path = getCurrentPath();
    var pageKey = getPageKeyFromPath(path);

    if (path.indexOf("/products/") === 0 || explicit === "product") {
      return "product";
    }

    if (path.indexOf("/collections/") === 0 || explicit === "collection") {
      return "product";
    }

    if (SIZING_PAGE_KEYS[pageKey]) {
      return "sizing";
    }

    if (FAQ_PAGE_KEYS[pageKey] || path.indexOf("/policies/") === 0) {
      return "faq";
    }

    if (PATHOLOGY_PAGE_KEYS[pageKey]) {
      return "pathology";
    }

    if (EDUCATION_PAGE_KEYS[pageKey] || explicit === "page" || explicit === "article") {
      return "education";
    }

    return "other";
  }

  function normalizeSource(source) {
    if (!source) {
      return null;
    }

    if (typeof source === "string") {
      var href = normalizeStorefrontHref(source.trim());
      var path = "";

      try {
        path = String(new window.URL(href, window.location.origin).pathname || "").replace(/\/+$/, "");
      } catch (_error) {
        path = normalizeComparableUrl(href);
      }

      var normalizedPathKey = path.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/)/i, "");
      var pageKey = getPageKeyFromPath(normalizedPathKey);

      return {
        url: href,
        normalizedPathKey: normalizedPathKey,
        localeCode: getLocale(),
        pageType: PATHOLOGY_PAGE_KEYS[pageKey] ? "pathology" : "",
        title: "",
      };
    }

    return source;
  }

  function showTyping() {
    hideTyping();

    state.typingId = "typing-" + Date.now();
    var wrapper = document.createElement("div");
    wrapper.className = "biopods-chat__message biopods-chat__message--assistant";
    wrapper.setAttribute("data-typing-id", state.typingId);

    var bubble = document.createElement("div");
    bubble.className = "biopods-chat__bubble";
    bubble.innerHTML =
      '<span class="biopods-chat__typing"><span class="biopods-chat__typing-dot"></span><span class="biopods-chat__typing-dot"></span><span class="biopods-chat__typing-dot"></span></span>';

    wrapper.appendChild(bubble);
    messagesEl.appendChild(wrapper);
    scheduleScrollToLatestQuestion();
  }

  function hideTyping() {
    if (!state.typingId) {
      return;
    }

    var existing = messagesEl.querySelector('[data-typing-id="' + state.typingId + '"]');
    if (existing) {
      existing.remove();
    }

    state.typingId = "";
  }

  function setPanelOpen(isOpen) {
    toggleButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.hidden = !isOpen;

    if (isOpen) {
      ensureSessionStarted().catch(function () {
        setStatus("The assistant is not available right now.");
      });
      setTimeout(function () {
        inputEl.focus();
      scheduleScrollToLatestQuestion();
      }, 10);
    }
  }

  function setStatus(message) {
    statusEl.textContent = message || "";
  }

  function clearStatus() {
    statusEl.textContent = "";
  }

  function scrollMessagesToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function scrollMessagesToLatestQuestion() {
    var userMessages = messagesEl.querySelectorAll('[data-chat-role="user"]');
    var latestUserMessage = userMessages.length ? userMessages[userMessages.length - 1] : null;

    if (!latestUserMessage) {
      scrollMessagesToBottom();
      return;
    }

    var containerRect = messagesEl.getBoundingClientRect();
    var messageRect = latestUserMessage.getBoundingClientRect();
    var delta = messageRect.top - containerRect.top;
    messagesEl.scrollTop = Math.max(0, messagesEl.scrollTop + delta - 8);
  }

  function scheduleScrollToLatestQuestion() {
    scrollMessagesToLatestQuestion();
    window.requestAnimationFrame(scrollMessagesToLatestQuestion);
    window.setTimeout(scrollMessagesToLatestQuestion, 40);
    window.setTimeout(scrollMessagesToLatestQuestion, 120);
  }

  function getPageUrl() {
    return window.location.href.split("#")[0];
  }

  async function postJson(path, payload) {
    var response = await window.fetch(apiBase + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    var data = {};

    try {
      data = await response.json();
    } catch (_error) {
      data = {};
    }

    if (!response.ok) {
      throw new Error(data.error || "Request failed.");
    }

    return data;
  }
})();
